export enum TemperatureThreshold {
    alert = 'Facility users will see a notable event when an elevated temperature persists at or above the desired threshold (1 notification per 6 hours).'
}
